import { Button } from "react-bootstrap";
import { FaMap } from "react-icons/fa";
import { Link } from "react-router";

export default function MapButton(props) {
    return (
        <Button
            variant="outline-secondary"
            as={Link}
            to={props.url}
            className={props.className}
            size={props.size}
        >
            <FaMap className="me-2" />
            Map
        </Button>
    );
}
